import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Play, Images, Loader2, Lock } from "lucide-react";
import { mediaUrl } from "@/lib/api";

export function Thumb({ c, testId }: { c: any; testId?: string }) {
  const m = c.media?.[0];
  const src = m ? (m.kind === "video" ? m.thumb_url : m.url) : null;
  return (
    <Link to={c.status === "draft" ? `/pubblica?draft=${c.id}` : `/c/${c.id}`} data-testid={testId || "content-thumb"}
      className="relative block aspect-[4/5] bg-white/5 overflow-hidden group">
      {src ? <img src={mediaUrl(src)} alt={c.caption || "Contenuto"} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        : <div className="w-full h-full flex items-center justify-center text-white/30 label">{c.status === "draft" ? "Bozza" : "—"}</div>}
      <div className="absolute top-2 right-2 flex gap-1">
        {c.type === "video" && <Play size={16} fill="currentColor" />}
        {c.type === "gallery" && <Images size={16} />}
        {c.visibility === "connections" && <Lock size={14} />}
      </div>
      {c.status !== "published" && (
        <div className="absolute inset-x-0 bottom-0 bg-black/70 px-2 py-1 label flex items-center gap-1">
          {c.status === "processing" && <Loader2 size={12} className="animate-spin" />}
          {{ draft: "Bozza", processing: "In elaborazione", removed: "Rimosso" }[c.status as string] || c.status}
        </div>
      )}
    </Link>
  );
}

export function ContentGrid({ items, testId }: { items: any[]; testId?: string }) {
  return (
    <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-[2px]" data-testid={testId}>
      {items.map((c) => <Thumb key={c.id} c={c} />)}
    </div>
  );
}

export function Countdown({ to, className = "" }: { to: string; className?: string }) {
  const [left, setLeft] = useState(() => new Date(to).getTime() - Date.now());
  useEffect(() => {
    const iv = setInterval(() => setLeft(new Date(to).getTime() - Date.now()), 1000);
    return () => clearInterval(iv);
  }, [to]);
  const s = Math.max(0, Math.floor(left / 1000));
  const pad = (n: number) => String(n).padStart(2, "0");
  return <span className={`font-mono tabular-nums ${className}`} data-testid="countdown">{pad(Math.floor(s / 3600))}:{pad(Math.floor((s % 3600) / 60))}:{pad(s % 60)}</span>;
}
